<!--
 * @Author: wangxiaoheng 1975858873@qq.com
 * @Date: 2024-07-07 14:21:14
 * @LastEditors: wangxiaoheng 1975858873@qq.com
 * @LastEditTime: 2024-07-09 09:42:13
 * @FilePath: \megagame_web\src\views\Channel.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="channel-main">
    <router-view />
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.channel-main {
  height: 100vh;
  width: 100%;
  max-width: 10rem;
}
</style>
